/* It's a TypeScript React library. */
const formReggie = {
    /******************************************************* Formatters *****************************************************************************/
    formatPhone: (input: string) => {//returns string
        let cleaned = ('' + input).replace(/\D/g, '')
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            let intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null
    },
    formatThousands: (number: number) => {//returns string
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    /******************************************************* Validators *****************************************************************************/
    validateMail: (mail: string) => {//returns boolean
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(mail).toLowerCase())
    },
    validatePhone: (phone: string) => {//returns boolean
        //r-18-lint-bk
        //eslint-disable-next-line
        const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
        return re.test(String(phone).toLowerCase())
    },
    /******************************************************* Other *****************************************************************************/
    deCamel: (str: string) => {//returns a string split by uppercase letters
        return str.replace(/([a-z])([A-Z])/g, '$1 $2')
    },
    titleCase: (str: string) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        })
    },
    allCaps: (str: string) => {
        return str.toUpperCase()
    },
    lowercase: (str: string) => {
        return str.toLowerCase()
    },
    restrictChars: (str: string, max: number) => {
        if (str.length > max) {
            return str.substr(0, max) + '...'
        } else {
            return str
        }
    },
    isDate: (str: string) => {
        const re = /^\d{2}([./-])\d{2}\1\d{4}$/
        return re.test(str)
    },
    isURL(str: string) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str)
    }
}
export default formReggie